import React, { memo, useContext } from "react";
import { useState } from "react";

import AlertaContext from "../../../../../Context/Alerta/AlertaContext";
import AuthContext from "../../../../../Context/Auth/AuthContext";
// MATERIAL
import { makeStyles } from "@mui/styles";
import {
  Box,
  IconButton,
  TableCell,
  TableRow,
  TextField,
  FormControlLabel,
  Checkbox,
  FormControl,
  Autocomplete,
} from "@mui/material";
import { Cancel, Check } from "@mui/icons-material";
const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  celda: {
    fontSize: ".7rem !important",
  },
  margin: {
    margin: "0px",
    padding: "2px",
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "2px",
  },
}));
const RowAgregarArma = (props) => {
  const [cargando, setcargando] = useState(false);
  const { usuario } = useContext(AuthContext);

  const { mostrarAlerta } = useContext(AlertaContext);
  const {
    // agregar,
    setagregar,
    setcontabilidadData,
    contabilidadData,
    // setitem,
    item,
    observacionContabilidad,
    editar,
    planDeCuentas,
  } = props;

  const [itemHijoNuevo, setitemHijoNuevo] = useState({
    contaId: 0,
    contaCodigo: "",
    contaTipo: "COMPRA",
    contaRuc: "",
    contaNombre: "",
    contaDocumento: "",
    contaFechaDoc: "",
    contaCuenta: "",
    contaCuentaNombre: "",
    contaObservacion: "",
    contaDebe: "0",
    contaHaber: "0",
    contaEstado: "ACTIVO",
    contaUser: "",
    contaEmpresa: "",
    contaFecReg: "",
    contaOption: "COMPRA",
    Todos: "",
  });
  const handleChange = (e) => {
    setitemHijoNuevo({
      ...itemHijoNuevo,
      [e.target.name]: e.target.value,
    });
  };
  const botonDisabled = () => {
    if (
      itemHijoNuevo.contaCuenta === "" ||
      itemHijoNuevo.contaCuentaNombre === "" ||
      itemHijoNuevo.contaDebe === "" ||
      itemHijoNuevo.contaHaber === ""
    ) {
      return true;
    } else {
      return false;
    }
  };
  const classes = useRowStyles();
  //gql eliminar user

  const handleAgregar = async () => {
    try {
      setcargando(true);

      const resItem = {
        ...itemHijoNuevo,
        // contaRuc: item.rucProveedor,
        // contaNombre: item.nomProveedor,
        // contaDocumento: item.factura,
        // contaFechaDoc: item.fechaFactura,
        contaObservacion: observacionContabilidad,
        contaUser: usuario.usuario,
        contaEmpresa: usuario.rucempresa,
        contaCodigo: editar ? item.compId : itemHijoNuevo.contaCodigo,
      };

      const mantenimientosDataR = [resItem, ...contabilidadData];
      mostrarAlerta("Contabilidad: Creado Correctamente", "success");
      setcontabilidadData(mantenimientosDataR);

      setcargando(false);
    } catch (error) {
      setcargando(false);
    }
  };
  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell padding="none" style={{ borderRight: "1px solid #ccc" }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-around"
            ml={1}
            mr={1}
          >
            <IconButton
              className={classes.margin}
              disabled={cargando}
              color={cargando ? "inherit" : "secondary"}
              onClick={() => {
                setagregar(false);
                setitemHijoNuevo({
                  contaId: 0,
                  contaCodigo: "",
                  contaTipo: "COMPRA",
                  contaRuc: "",
                  contaNombre: "",
                  contaDocumento: "",
                  contaFechaDoc: "",
                  contaCuenta: "",
                  contaCuentaNombre: "",
                  contaObservacion: "",
                  contaDebe: "0",
                  contaHaber: "0",
                  contaEstado: "ACTIVO",
                  contaUser: "admin",
                  contaEmpresa: "NE2021",
                  contaFecReg: "",
                  contaOption: "COMPRA",
                  Todos: "",
                });
              }}
            >
              <Cancel fontSize="small" />
            </IconButton>
            <IconButton
              className={classes.margin}
              disabled={botonDisabled() || cargando}
              color={botonDisabled() || cargando ? "inherit" : "secondary"}
              onClick={async () => {
                await handleAgregar();

                setagregar(false);
                setitemHijoNuevo({
                  contaId: 0,
                  contaCodigo: "",
                  contaTipo: "COMPRA",
                  contaRuc: "",
                  contaNombre: "",
                  contaDocumento: "",
                  contaFechaDoc: "",
                  contaCuenta: "",
                  contaCuentaNombre: "",
                  contaObservacion: "",
                  contaDebe: "0",
                  contaHaber: "0",
                  contaEstado: "ACTIVO",
                  contaUser: "admin",
                  contaEmpresa: "NE2021",
                  contaFecReg: "",
                  contaOption: "COMPRA",
                  Todos: "",
                });
              }}
            >
              <Check fontSize="small" />
            </IconButton>
            <FormControlLabel
              className={classes.margin}
              onChange={(e) => {
                setitemHijoNuevo({
                  ...itemHijoNuevo,
                  contaEstado: e.target.checked ? "ACTIVO" : "INACTIVA",
                });
              }}
              control={
                <Checkbox
                  value="ACTIVO"
                  className={classes.margin}
                  checked={
                    itemHijoNuevo["contaEstado"] === "ACTIVO" ? true : false
                  }
                  color="primary"
                />
              }
            />
          </Box>
        </TableCell>
        {/* las demas columnas */}

        <>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            <FormControl fullWidth>
              <Autocomplete
                options={planDeCuentas.map((item) => {
                  return item.plancCodigo + "/+/" + item.plancNombre;
                })}
                getOptionLabel={(option) => {
                  return option.replace("/+/", " ");
                }}
                id="controlled-demo"
                value={itemHijoNuevo.contaCuenta}
                paperprops
                onChange={async (event, newValue) => {
                  if (newValue) {
                    const options = newValue.split("/+/");
                    setitemHijoNuevo({
                      ...itemHijoNuevo,
                      contaCuenta: options[0],
                      contaCuentaNombre: options[1],
                    });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    onChange={async (e) => {
                      if (e.target.value === "") {
                        return mostrarAlerta("Ingrese una cuenta", "error");
                      }
                      try {
                        // setproveedoresData(res.data.data);
                      } catch (error) {}
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </FormControl>
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            <TextField
              disabled
              size="small"
              fullWidth
              value={itemHijoNuevo.contaCuentaNombre}
              name="contaCuentaNombre"
              onChange={(e) => handleChange(e)}
            />
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            <TextField
              type="number"
              size="small"
              fullWidth
              value={itemHijoNuevo.contaDebe}
              name="contaDebe"
              onChange={(e) => handleChange(e)}
            />
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            <TextField
              type="number"
              size="small"
              fullWidth
              value={itemHijoNuevo.contaHaber}
              name="contaHaber"
              onChange={(e) => handleChange(e)}
            />
          </TableCell>
          {/* "contaObservacion": "La paz => actualizado este registro", */}
        </>
      </TableRow>
    </React.Fragment>
  );
};

export default memo(RowAgregarArma);
